import fetchAllStategy from './fetchAll'
import fetchStategy from './fetch'
import createStategy from './create'
import updateStategy from './update'
import updatePositionsStategy from './updatePositions'
import deleteStategy from './delete'
import refreshStrategy from './refresh'

export {
  fetchAllStategy as fetchAll,
  fetchStategy as fetch,
  createStategy as create,
  updateStategy as update,
  updatePositionsStategy as updatePositions,
  deleteStategy as delete,
  refreshStrategy as refresh
}

export default {
  fetchAll: fetchAllStategy,
  fetch: fetchStategy,
  create: createStategy,
  update: updateStategy,
  updatePositions: updatePositionsStategy,
  delete: deleteStategy,
  refresh: refreshStrategy
}
